import styled from '@emotion/styled';

interface TableUsernameFormatterProps {
  data?: Record<string, any>;
  startKey?: string;
  endKey?: string;
}

const TableUsernameFormatter: React.FC<TableUsernameFormatterProps> = ({
  data,
  startKey,
  endKey,
}) => {
  const startName = data?.[startKey ?? '']?.capitalize?.();
  const endName = data?.[endKey ?? '']?.capitalize?.();
  return (
    <Container>
      {startName} {endName}
    </Container>
  );
};

export default TableUsernameFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;
